// extracted by mini-css-extract-plugin
export default {"area":"Cursor_area__jT9H2","inner":"Cursor_inner__M51s0"};